import { fetchAndParse } from '../utils/ajax';

// Fetching all the service invoker requests for a given state ID
export const getServiceInvokerRequestsByState = ({ authenticationToken, tenantId, stateId, page = 1, pageSize = 1000 }) => fetchAndParse({
    url: `/api/service/1/requests/state/${stateId}?page=${page}&pageSize=${pageSize}`,
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});

// Fetch the given service invoker request by ID
export const getServiceInvokerRequest = ({ authenticationToken, tenantId, requestId }) => fetchAndParse({
    url: `/api/service/1/requests/${requestId}`,
    method: 'GET',
    headers: {
        Authorization: authenticationToken,
        ManyWhoTenant: tenantId,
    },
});
